import React, { useState } from "react";
import {
  Button,
  Box,
  TextField,
  InputAdornment,
  Paper,
  Typography,
  Stack,
  IconButton,
  Select,
  FormControl,
  MenuItem,
  InputLabel,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import SendIcon from "@mui/icons-material/Send";
import ClearIcon from "@mui/icons-material/Clear";
import { addMockupMail } from "../../../api";
import orderMockupTemplate from "../../../components/orderMockupTemplate";
import PreviewTemplate from "../../../components/utils/PreviewTemplate";
import Alert from "@mui/material/Alert";
import { useDropzone } from "react-dropzone";
import { EditorState, convertToRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import TrackEvents from "../../../api/amplitudeEvents";
import orderMockupBlank from "../../../components/orderMockupBlank";
const useStyles = makeStyles((theme) => ({
  paper: {
    position: "relative",
  },
  dropbox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fafafa",
    padding: "24px;",
    borderWidth: 1,
    borderRadius: 4,
    borderColor: "rgba(0, 0, 0, 0.12)",
    borderStyle: "solid",
    marginTop: "8px",
    marginBottom: "4px",
    cursor: "pointer",
    color: "#bdbdbd",
    outline: "none",
    transition: "border .24s ease-in-out",
  },
  dropboxactive: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px;",
    borderWidth: 1,
    borderRadius: 4,
    borderColor: "#000",
    backgroundColor: "#fafafa",
    borderStyle: "solid",
    marginTop: "8px",
    marginBottom: "4px",
    cursor: "pointer",
    color: "#bdbdbd",
    outline: "none",
    transition: "border .24s ease-in-out",
  },
  text: {
    fontSize: "18px",
    color: "#bdbdbd",
  },
}));

const Mail = (props) => {
  const classes = useStyles();
  const { order, res, setRes } = props;
  const { billing, id } = order;
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [feilds, setFeilds] = useState({
    customeremail: billing?.email,
    mailsubject: `Mockup For Order #${id}`,
    mailmessage: "",
  });
  const [open, setOpen] = useState(false);
  const [templates, setTemplates] = useState("orderMockupTemplate");

  const [alertString, setAlertString] = useState("");
  const [alert, setAlert] = useState(false);
  const [responseSeverity, setResponseSeverity] = useState("");
  const userid = localStorage.getItem("auth_id");
  const [editorState, setEditorState] = React.useState(
    EditorState.createEmpty()
  );
  const handleClose = () => {
    setOpen(false);
  };

  // const handleFileUpload = (e) => {
  //   e.preventDefault();
  //   let allfiles = [];
  //   for (let i = 0; i < e.target.files.length; i++) {
  //     allfiles.push(e.target.files[i]);
  //   }
  //   if (allfiles.length > 0) {
  //     setFiles(allfiles);
  //   }
  // };

  const handleChange = (e) => {
    setFeilds({ ...feilds, [e.target.name]: e.target.value });
  };

  const handleBlankSubject = () => {
    setFeilds({
      mailsubject: `Message From Printyo on Order #${id}`,
      customeremail: billing?.email,
    });
  };

  const handleMockupSubject = () => {
    setFeilds({
      mailsubject: `Mockup For Order #${id}`,
      customeremail: billing?.email,
    });
  };

  const handleSelectTemplate = (e) => {
    setTemplates(e.target.value);
  };

  const handleSubmit = async () => {
    var data = new FormData();
    let template = "";
    if (templates === "orderMockupTemplate") {
      template = orderMockupTemplate(order, feilds.mailmessage);
    } else if (templates === "orderMockupBlankTemplate") {
      template = orderMockupBlank(order, feilds.mailmessage);
    }
    // const template = orderMockupTemplate(order, feilds.mailmessage);
    data.append("customeremail", feilds.customeremail);
    data.append("mailsubject", feilds.mailsubject);
    data.append("mailmessage", template);
    data.append("userid", userid);
    files.forEach((item) => data.append("emailattachmenturl[]", item));
    try {
      setLoading(true);
      const response = await addMockupMail(id, data);
      if (response.status === 200) {
        setAlert(true);
        setAlertString("Mail sent successfully");
        setResponseSeverity("success");
        setFeilds({
          customeremail: billing?.email,
          mailsubject: "",
          mailmessage: "",
          Bcc: "",
        });
        setRes(!res);
        setFiles([]);
        TrackEvents(`${id}`, {
          process: "Mockup Mail sent In Pending Order",
        });
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error from mockup", error);
      setAlert(true);
      setAlertString("Something went wrong while sending mail to the user");
      setResponseSeverity("error");
    }
  };

  const onEditorStateChange = (editorState) => {
    setEditorState(editorState);
    setFeilds({
      ...feilds,
      ["mailmessage"]: draftToHtml(
        convertToRaw(editorState.getCurrentContent())
      ),
    });
  };
  // Dropzone

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: "image/*",
    multiple: true,
    onDrop: (acceptedFiles) => {
      setFiles(
        acceptedFiles.map((files) =>
          Object.assign(files, {
            preview: URL.createObjectURL(files),
          })
        )
      );
    },
  });

  // const images = files.map((files) => (
  //   <div key={files.name}>
  //     <div>
  //       <img src={files.preview} style={{ width: "200px" }} alt="preview" />
  //     </div>
  //   </div>
  // ));

  const handleCancelUpload = (key) => {
    const filteredFiles = files.filter((item, i) => i !== key);
    setFiles(filteredFiles);
  };

  return (
    <Paper sx={{ p: 3, mt: 4 }} className={classes.paper}>
      <PreviewTemplate
        open={open}
        handleClose={handleClose}
        template={templates}
        msg={feilds.mailmessage}
        order={order}
      />
      {alert ? (
        <Alert
          severity={responseSeverity}
          sx={{
            margin: "10px 0 20px",
          }}
        >
          {alertString}
        </Alert>
      ) : null}
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography
          sx={{
            color: "#3c434a",
            fontSize: "15px",
            lineHeight: "1.4em",
            fontWeight: "bold",
          }}
        >
          Send mail
        </Typography>
        <Stack direction="row" alignItems="center">
          <FormControl>
            <InputLabel id="demo-simple-select-label">Template</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={templates}
              label="Template"
              size="small"
              onChange={handleSelectTemplate}
            >
              <MenuItem
                value={"orderMockupTemplate"}
                onClick={handleMockupSubject}
              >
                Mockup Template
              </MenuItem>
              <MenuItem
                value={"orderMockupBlankTemplate"}
                onClick={handleBlankSubject}
              >
                Blank Temaplate
              </MenuItem>
            </Select>
          </FormControl>
          <Button
            className={classes.activityPreviewBtn}
            size="small"
            variant="text"
            color="primary"
            sx={{ ml: 2 }}
            onClick={() => setOpen(true)}
          >
            preview
          </Button>
        </Stack>
      </Stack>

      <TextField
        id="outlined-start-adornment"
        fullWidth
        InputProps={{
          startAdornment: <InputAdornment position="start">To</InputAdornment>,
        }}
        type="email"
        size="small"
        name="customeremail"
        value={feilds.customeremail}
        margin="dense"
        onChange={handleChange}
      />
      <TextField
        id="outlined-start-adornment"
        fullWidth
        size="small"
        name="mailsubject"
        placeholder="Subject"
        margin="dense"
        value={feilds.mailsubject}
        onChange={handleChange}
      />
      <>
        <Box
          {...getRootProps()}
          className={isDragActive ? classes.dropboxactive : classes.dropbox}
        >
          <input {...getInputProps()} />
          <Typography className={classes.text}>
            Drag 'n' drop some files here, or click to select files
          </Typography>
        </Box>
      </>
      {files?.length > 0 && (
        <Box
          sx={{
            border: "1px solid rgba(0, 0, 0, 0.12)",
            borderRadius: "4px",
            p: 1,
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            marginTop: "8px",
          }}
        >
          {files.map((file, key) => {
            return (
              <Stack
                direction="row"
                alignItems="center"
                key={key}
                sx={{
                  border: "1px solid rgba(0, 0, 0, 0.12)",
                  borderRadius: "4px",
                  px: 1,
                  mr: 1,
                }}
              >
                <img
                  src={URL.createObjectURL(file)}
                  alt={file.name}
                  style={{ height: "20px" }}
                />
                <Box ml={2}>{file.name}</Box>
                <IconButton onClick={() => handleCancelUpload(key)}>
                  <ClearIcon size="small" />
                </IconButton>
              </Stack>
            );
          })}
        </Box>
      )}
      {/* <TextField
        id="filled-multiline-flexible"
        multiline
        margin="dense"
        rows={8}
        name="mailmessage"
        value={feilds.mailmessage}
        placeholder="If you want to add any other information to the mail, please add it here."
        onChange={handleChange}
        fullWidth
      /> */}
      <Box
        display="flex"
        alignItems="center"
        mt={2}
        p={1}
        sx={{
          border: 1,
          borderColor: "grey.500",
          borderRadius: 1,
        }}
      >
        <Editor
          editorState={editorState}
          wrapperClassName="wrapper-class"
          editorClassName="editor-class"
          toolbarClassName="toolbar-class"
          onEditorStateChange={onEditorStateChange}
          placeholder="If you want to add any other information to the mail, please add it here."
          toolbar={{
            options: ["blockType", "inline"],
            inline: {
              inDropdown: false,
              options: ["bold", "italic", "underline", "strikethrough"],
            },
            blockType: {
              inDropdown: false,
              options: ["H1", "H2", "H3", "H4", "H5", "H6", "Blockquote"],
            },
          }}
        />
      </Box>

      <Box display="flex" alignItems="center" justifyContent="flex-end" mt={2}>
        <Button
          variant="contained"
          endIcon={<SendIcon />}
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Sending" : "Send"}
        </Button>
      </Box>
    </Paper>
  );
};

export default Mail;
